module.exports = __webpack_public_path__ + "img/block-trial.c282aa68.svg";